const comments = [
  {
    avatar: '匿',
    name: '吃瓜一线网友',
    time: '2小时前',
    content: '这个瓜我真的吃了三天三夜还没消化完，剧情反转也太精彩了吧！每天打开911吃瓜网都有新惊喜，比追剧还刺激！',
    likes: 1283,
  },
  {
    avatar: '爆',
    name: '娱乐观察家',
    time: '5小时前',
    content: '作为老粉必须说一句，911吃瓜网的整理能力真的强，每次热点事件都能把时间线理得清清楚楚，不会看得一头雾水。',
    likes: 967,
  },
  {
    avatar: '瓜',
    name: '深夜吃瓜人',
    time: '8小时前',
    content: '凌晨三点还在刷今天吃瓜的我，谁能想到一个八卦网站能让人这么上头……最新热点更新太快了根本停不下来！',
    likes: 2451,
  },
  {
    avatar: '热',
    name: '八卦小能手',
    time: '12小时前',
    content: '围观了一个月的连续剧终于大结局了，感谢911吃瓜网的一路追踪报道，每篇都看，比当事人还清楚事情来龙去脉。',
    likes: 756,
  },
  {
    avatar: '火',
    name: '路人转铁粉',
    time: '1天前',
    content: '偶然发现这个宝藏网站，从此打开了新世界的大门。每日吃瓜实时更新这个功能太贴心了，社畜摸鱼必备！',
    likes: 1832,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">网友热评</h2>
          <span className="text-xs text-foreground-400">大家正在讨论</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}